var QF_CONST = {
    STYLE: 'background: white; color:blue;',
    STYLE_OK: 'background: green; color:white;',
    STYLE_WARN: 'background:red; colour:white;'
};

function formAttributePrefix(){
    var $field = $('[name^=tx_forms_quote]').first();
    if(!$field.length) {
        return;
    }
    return $field.attr('name').split('[')[0]

}

var QF_FIELDS = QF_FIELDS ? QF_FIELDS : {};
QF_FIELDS.PL = {

    CURRENCY_NAME: formAttributePrefix() + "[object][currency]",
    PRIVATE_USE: formAttributePrefix() + "[object][privateUse]",
    SKIPPER_CHARTER: formAttributePrefix() + "[object][skipperCharter]",
    BAREBOAT_CHARTER: formAttributePrefix() + "[object][bareboat]",
    PREVIOUS_INSURANCE: formAttributePrefix() + "[object][prevInsurance]",
    WILL_BE_LEASED: formAttributePrefix() + "[object][leased]",
    SUM_TYPE: formAttributePrefix() + "[object][sumType]",

    VALUE_GROUP: 'yachtInsuranceValue',
    QUOTE_GROUP: 'quotationAreaGroup'
};
var QF_EVENTS = QF_EVENTS ? QF_EVENTS : {};
QF_EVENTS.PL = {
    step1: "pl_quote_step_boatdata",
    step2: "pl_quote_step_personaldata",
    step3: "pl_quote_step_summary",
    confirm: "pl_quote_step_confirmation"
};

function logForm(message, data, style) {
    var dataVars = data || false;
    var stylenamestub = 'STYLE';
    style = style ? stylenamestub+'_'+style : stylenamestub;
    if (window._pants && "dev" === window._pants.env) {
        console.groupCollapsed('%c' + message, QF_CONST[style]);
        dataVars && console.log('data: ',dataVars);
        console.trace('trace:');
        console.groupEnd();

    }
}

function initQuoteForm() {
    var $form = $("#quotationForm");

    if ($form.length) {
        logForm("quote_form_test",false, 'WARN');
        
        $form.find('.quof-progressBlock').hide();
        
        $form.find('#quof-progressBlock1').show().addClass('active');
        $form.find('*[data-block-id="quof-progressBlock1"]').show().addClass('active');
        
        initQuoteFormButtons($form);
        
        initSwitchFields($form);
        var $valueGroup = $form.find('.{1}'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP));
        $form.find("."+ QF_FIELDS.PL.VALUE_GROUP, '[name="{1}"]'.replace('{1}', QF_FIELDS.PL.CURRENCY_NAME)).on("change keyup click", function(){
            updateSumGroup(".yachtValueGroup");
        });
        
        var $currencySelect = $form.find('[name="{1}"]'.replace('{1}', QF_FIELDS.PL.CURRENCY_NAME));
        if($currencySelect.length > 0){
            $currencySelect.on('click', function () {
                if($valueGroup.length) {
                    $valueGroup.prop('disabled', false);
                }
                
                var currency = getSelectedCurrency();
                
                $('.valueGroupCurrencyLabel').html(currency.symbol);
                updateSumGroup(".yachtValueGroup");
            });
        }
        else{

            var currency = getSelectedCurrency();
            $('.valueGroupCurrencyLabel').html(currency.symbol);
            updateSumGroup(".yachtValueGroup");
        }

        trackStep1();
        initQuoteFormSubmit();

    }


}
var qf_init_wait_count = 0;
function trackStep1() {
    if(window.dataLayer && window.dataLayer.length) {
        trackEvent(QF_EVENTS.PL.step1);
    } else {
        if(qf_init_wait_count<4) {
            // console.log('waiting...');
            setTimeout(trackStep1, 2500);
            qf_init_wait_count++;
        } else {
            // console.log('wait cancelled');
        }
    }
}

function initQuoteFormButtons($form) {
    $form.find(".buttonPrev").unbind().click(function () {
        logForm("qf prev");
        quoteFormStep($form, $form.find(".progressViewElement.active").prev(), false);
    });
    $form.find(".buttonNext").unbind().click(function () {
        logForm("qf next");
        quoteFormStep($form, $form.find(".progressViewElement.active").next(), true);
    });

    $form.find(".summaryChangeButton").click(function(e){
        e.preventDefault();
        var id = parseInt($(this).attr("data-id"))-1;
        quoteFormStep($form, $form.find(".progressViewElement").eq(id), false);
    });
    $form.find(".buttonPrev").on("keydown", handleKeyDownForClick);
	$form.find(".buttonNext").on("keydown", handleKeyDownForClick);
	$form.find(".summaryChangeButton").on("keydown", handleKeyDownForClick);
}

function quoteFormStep($form, $progressElement, validate) {
    var formValid = true;
    if (validate) {
        formValid = validateQuoteForm($form.find('.quof-progressBlock.active'));
    }

    //formValid = true;

    if (validate && formValid) {
        logForm("form validated");

        initQuoteFormButtons($form);

        updateQuoteFormSummary($form);

        // updateRacingYachtInsuranceHullValue();

    }  else if(validate && !formValid) {
        logForm("form validation error");
        scrollToError();
        // validation error!
    }

    if (formValid) {
        var blockId = $progressElement.attr("data-block-id");
        $form.find(".progressViewElement").removeClass("active");
        $progressElement.addClass("active");
        $progressElement.removeClass("disabled");
        $form.find(".quof-progressBlock").hide().removeClass("active");
        $form.find("#" + blockId).show().addClass("active");

        $('html, body').animate({
            scrollTop: $progressElement.offset().top - 60
        }, 100);

        var stepEvent = "";
        switch($progressElement.index()) {
            case 0:
                stepEvent = QF_EVENTS.PL.step1;
                break;
            case 1:
                stepEvent = QF_EVENTS.PL.step2;
                break;
            case 2:
                stepEvent = QF_EVENTS.PL.step3;
                break;
            default:
        }

        trackEvent(stepEvent, null );
    }
}

function validateQuoteForm($formStep) {

    var $currentBlock = $formStep;

    //testing!
    // return true;
    //testing!

    var error = false;

    $currentBlock.find("input").each(function () {
        if (validateFormField($(this))) {
            //console.log("validateQuoteForm() A");
            error = true;
        }
    });
    $currentBlock.find("textarea").each(function () {
        if (validateFormField($(this))) {
            //console.log("validateQuoteForm() B");
            error = true;
        }
    });
    $currentBlock.find("select").each(function () {
        if (validateFormField($(this))) {
            //console.log("validateQuoteForm() C");
            error = true;
        }
    });
    
    if($('[name="'+QF_FIELDS.PL.PRIVATE_USE+'"]').length > 0){
        var privateUSe = $('[name="'+QF_FIELDS.PL.PRIVATE_USE+'"]:checked');
        error = validateCheckboxGroup(privateUSe, 'formFieldPrivateUse', error);
    }

    if($('[name="'+QF_FIELDS.PL.BAREBOAT_CHARTER+'"]').length > 0){
        var bareboatCharter = $('[name="'+QF_FIELDS.PL.BAREBOAT_CHARTER+'"]:checked');
        error = validateCheckboxGroup(bareboatCharter, 'formFieldBareboatCharter', error);
    }
    
    if($('[name="'+QF_FIELDS.PL.SKIPPER_CHARTER+'"]').length > 0){
        var skipperCharter = $('[name="'+QF_FIELDS.PL.SKIPPER_CHARTER+'"]:checked');
        error = validateCheckboxGroup(skipperCharter, 'formFieldSkipperCharter', error);
    }

    if($('[name="'+QF_FIELDS.PL.CURRENCY_NAME+'"]').length > 0){
        var currencySel = $('[name="'+QF_FIELDS.PL.CURRENCY_NAME+'"]:checked');
        error = validateCheckboxGroup(currencySel, 'formFieldYachtValue', error);
    }
    
    if($('[name="'+QF_FIELDS.PL.SUM_TYPE+'"]').length > 0){
        var sumType = $('[name="'+QF_FIELDS.PL.SUM_TYPE+'"]:checked');
        error = validateCheckboxGroup(sumType, 'formFieldSumValueType', error);
    }
    
    if($('[name="'+QF_FIELDS.PL.PREVIOUS_INSURANCE+'"]').length > 0){
        var previousInsuranceSel = $('[name="'+QF_FIELDS.PL.PREVIOUS_INSURANCE+'"]:checked');
        error = validateCheckboxGroup(previousInsuranceSel, 'formFieldPreviousInsurance', error);
    }
    
    if($('[name="'+QF_FIELDS.PL.WILL_BE_LEASED+'"]').length > 0){
        var willBeLeasedSel = $('[name="'+QF_FIELDS.PL.WILL_BE_LEASED+'"]:checked');
        error = validateCheckboxGroup(willBeLeasedSel, 'formFieldWillBeLeased', error);
    }
    
    
    var $quoteGroup = $currentBlock.find('#'+QF_FIELDS.PL.QUOTE_GROUP);
    if($quoteGroup.length && $quoteGroup.find('input:checked').length < 1 ) {
        error = true;
        $quoteGroup.find('.form-field').first().addClass('error');
        //console.log("validateQuoteForm() X");
    } else {
        $quoteGroup.find('.form-field').first().removeClass('error');
        //console.log("validateQuoteForm() Y");
    }
    

    return !error;
}

function validateCheckboxGroup($checkfield, formFieldId, error) {

    if (!$checkfield.length) {
        error = true;
        $("#"+formFieldId).addClass("error");
        $("#" + formFieldId + " .errormessage").show();
    } else {
         $("#"+formFieldId).removeClass("error");
        $("#" + formFieldId + " .errormessage").hide();
    }

    return error;
}

function updateQuoteFormSummary($form){
    
    //add value to summary
    $form.find(".summaryData").each(function(){
        var id = $(this).attr("data-summary-id");
        var field = $form.find("#"+id);
        var value = "";

        if($(this).is("input")){
            value = $(this).val();

            if($(this).hasClass("yachtInsuranceValue")){
                var cur = getSelectedCurrency();
                value = $(this).val() + " " + cur.symbol;
            }
        }
        else if($(this).is("select")){
            value = $(this).val();
            if("selectboxGender" === this.id) {
                value = $(this).find('option[value="'+$(this).val()+'"]').html()
            }
        }
        else if($(this).is("textarea")){
            value = $(this).val();
        }

        if(value === ""){
            value = "-"
        }

        field.html(value);
    });

    var privateUse = $('[name="'+QF_FIELDS.PL.PRIVATE_USE+'"]:checked');
    if ( privateUse.length ) {
        var privateUseSelected = parseInt(privateUse.val());
        $('#quof-summary-privateUse .checkboxFlag').removeClass('checked');
        privateUseSelected ? $('#quof-summary-privateUse .flagYes').addClass('checked') : $('#quof-summary-privateUse .flagNo').addClass('checked')
    }

    var bareboatCharter = $('[name="'+QF_FIELDS.PL.BAREBOAT_CHARTER+'"]:checked');
    if ( bareboatCharter.length ) {
        var bareboatSelected = parseInt(bareboatCharter.val());
        $('#quof-summary-bareboatCharter .checkboxFlag').removeClass('checked');
        bareboatSelected ? $('#quof-summary-bareboatCharter .flagYes').addClass('checked') : $('#quof-summary-bareboatCharter .flagNo').addClass('checked')
    }
    var skipperCharter = $('[name="'+QF_FIELDS.PL.SKIPPER_CHARTER+'"]:checked');
    if ( skipperCharter.length ) {
        var skipperCharterSelected = parseInt(skipperCharter.val());
        $('#quof-summary-skipperCharter .checkboxFlag').removeClass('checked');
        skipperCharterSelected ? $('#quof-summary-skipperCharter .flagYes').addClass('checked') : $('#quof-summary-skipperCharter .flagNo').addClass('checked')
    }

    var sumValueType = $('[name="'+QF_FIELDS.PL.SUM_TYPE+'"]:checked');
    if ( sumValueType.length ) {
        var sumValueTypeSelected = sumValueType.val();
        $('#quof-summary-sumValueType .checkboxFlag').removeClass('checked');
        sumValueTypeSelected === 'net' ? $('#quof-summary-sumValueType .flagNet').addClass('checked') : $('#quof-summary-sumValueType .flagGross').addClass('checked')
    }

    var $prevInsuranceSummary = $('#previousInsuranceSummary');
    $prevInsuranceSummary.hide();
    var prevInsurance = $('[name="'+QF_FIELDS.PL.PREVIOUS_INSURANCE+'"]:checked');
    if (prevInsurance.length && parseInt(prevInsurance.val()) ) {
        $prevInsuranceSummary.show();
    }

    var $willBeLeasedSummary = $('#willBeLeasedSummary');
    $willBeLeasedSummary.hide();
    $('#quof-summary-leased .checkboxFlag').removeClass('checked');
    var willBeLeased = $('[name="'+QF_FIELDS.PL.WILL_BE_LEASED+'"]:checked');
    if (willBeLeased.length && parseInt(willBeLeased.val()) ) {
        $('#quof-summary-leased .flagYes').addClass('checked');
        $willBeLeasedSummary.show();
    } else {
        $('#quof-summary-leased .flagNo').addClass('checked');
    }
    var quoteAreaStringArray = [];
    $('#quotationAreaGroup').find('input:checked').each(function (idx, el) {
        quoteAreaStringArray.push($(el).val());
    });

    $('#quof-summary-quoteareas').html(quoteAreaStringArray.join(', '));

    var quoteMembershipStringArray = [];
    $('#fieldsMembership').find('input:checked').each(function (idx, el) {
        quoteMembershipStringArray.push($(el).val());
    });

    $('#quof-summary-quotemembers').html(quoteMembershipStringArray.join(', '));
}


function validateFormField($ff) {
    return getRacingYachtInsuranceFormFieldError($ff);
}

function initSwitchFields($form) {

    var $switchFields = $form.find('*[data-switch-container-id]');
    logForm("switch field: ", $switchFields, 'OK');

    $switchFields.hide();
    $switchFields.each(function (index, switchField) {
        var $switchField = $(switchField);
        var switchId = $switchField.data('switch-container-id');
        // logForm("switch field id: " + switchId);
        $form.find('*[data-switch-container-on="'+switchId+'"]').click(function(){
            $switchField.show();
            //$switchFields.find('input, textarea').prop('disabled', false);
            $switchFields.find('input, textarea').prop('aria-hidden', false);
            // logForm("form switch on event attached - id:" + switchId);
        });
        $form.find('*[data-switch-container-on="'+switchId+'"]').on("keydown", handleKeyDownForClick);

         $form.find('*[data-switch-container-off="'+switchId+'"]').click(function(){
             $switchField.hide();
             //$switchFields.find('input, textarea').prop('disabled', true);
             $switchFields.find('input, textarea').prop('aria-hidden', true);
           // logForm("form switch off event attached - id:" + switchId);
        });
        $form.find('*[data-switch-container-off="'+switchId+'"]').on("keydown", handleKeyDownForClick);
    });

}

function updateSumGroup(){
    var $form = $("#quotationForm");
    var currency = getSelectedCurrency();

   var sum = getQuoteFormInsuranceSum($form);

    if(sum > 0){
        $form.find('.{1}Sum'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP)).html(sum + " "+ currency.symbol);
        $form.find("#quof-summary-boatTotalSum").html(sum + " "+ currency.symbol);

        // $form.find('.{1}Sum'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP)).val(sum+ " "+ currency.symbol);
        $form.find('.{1}Sum'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP)).val(sum);
    }
    else{
        $form.find('.{1}Sum'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP)).html("");
        $form.find("#quof-summary-boatTotalSum").html("");

        $form.find('.{1}SumInput'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP)).val(0);
    }
}

function getQuoteFormInsuranceSum($form) {
    var sum = 0;
    $form.find('.{1}'.replace('{1}', QF_FIELDS.PL.VALUE_GROUP) ).each(function(){
        if($(this).val() !== ""){
            sum += parseInt($(this).val());
        }
    });
    return sum;
}

function getSelectedCurrency() {

    var $form = $("#quotationForm");
    var currencyChecked = $form.find('[name="{1}"]:checked'.replace('{1}', QF_FIELDS.PL.CURRENCY_NAME));
    var currencySelected = currencyChecked.length ? currencyChecked.val() : "EUR";
    var curVals = {
        'EUR' : {
            symbol:"€",
            locale: "de-DE",
            code:"EUR"
        },
        'PLN' : {
            symbol:"zł",
            locale: "pl-PL",
            code:"PLN"
        }
    };
    return curVals[currencySelected.toUpperCase()];
}

function initQuoteFormSubmit() {
    var $form = $('#quotationForm');
    var $desired = $form.find("#desiredStart");
    var $terms1 = $form.find("#checkboxConditionsField");
    var $terms2 = $form.find("#checkboxConditionsField2");

    $form.find('*[type="submit"]').click(function (e) {

        e.preventDefault();
        var termsAgreed = true;

        if($desired.length > 0 && $desired.val() === "") {
            // desired not filled
            termsAgreed = false;
            $desired.parent(".form-field").addClass('error');

        }
        if($terms1.length > 0 && !$terms1.find('input:checked').length ) {
            // terms1 not checked
            termsAgreed = false;
            $terms1.addClass('error');

        }
        if($terms2.length > 0 && !$terms2.find('input:checked').length ) {
            // terms1 not checked
            termsAgreed = false;
            $terms2.addClass('error');
        }

        if(termsAgreed) {
            var expires = new Date(new Date().getTime() + 5 * 60 * 1000); // 5 minutes
            var trackingData = {"currencyCode": getSelectedCurrency().code};
            var args = [QF_EVENTS.PL.confirm, getQuoteFormInsuranceSum($form), trackingData];
            var data = {"args": args, "fn": "trackEvent"};
            cookieSet('tracking_nonce', data, expires);

            $form.submit();
        } else {
            scrollToError();
        }
    })
}